import { Stack, Text, useTheme } from '@fluentui/react';

export const Header: React.FC = () => {
  const theme = useTheme();
  return (
    <Stack
      horizontal
      style={{
        borderBottom: `1px solid ${theme.palette.neutralLight}`,
        paddingBottom: 16,
      }}
    >
      <Text variant="large" style={{ fontWeight: 600 }}>
        Rules
      </Text>
      <Text variant="large" style={{ marginLeft: 440, fontWeight: 600 }}>
        Settings
      </Text>
    </Stack>
  );
};
